export type WishlistAuth = 'user' | 'anonymous';

export const wishlistKeys = {
    all: ['wishlist'] as const,
    list: (auth: WishlistAuth, world: string) => [...wishlistKeys.all, 'list', auth, world] as const
} as const;

// Invalidations:
// TODO FE-255: populate when the wishlist mutations land — list each mutation → the keys it invalidates
